import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";

const EditPartCategory = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editpartcategory, setEditPArtCAtegory] = useState([]);
  const [userTypedd, setUserTypedd] = useState([]);
  const authToken = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const navigate = useNavigate();
  const Token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPArtCAtegory = async () => {
    try {
      const response = await axiosInstance.get(
        `/partcategory/edit/${data.part_category_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const fetchedData = response.data.data;

      const formatData = {
        part_category_name: fetchedData.part_category_name,
        part_category_desc: fetchedData.part_category_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id: fetchedData.business_partner_id,
      };
      setFormData(formatData);
      setEditPArtCAtegory(fetchedData);
      console.log(formData, "Partcategory DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPArtCAtegory();
  }, []);


  const handleFormSubmit = async (formData) => {
    // Validate form before submission
    const errors = {};
    let isValid = true;
  
    PartCAtegoryINputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
   
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this Part Category?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });
      if (confirmation.isConfirmed) {
        setLoading(true);
        const payload = {
          part_category_desc: formData.part_category_desc,
          part_category_name: formData.part_category_name,
          status: formData.status === "Active" ? 1 : 0,
        };
  
        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }
        const response = await axiosInstance.patch(`/partcategory/update/${data.part_category_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        });
        if (response.status === 200) {
          await Swal.fire({
            title: "Success",
            text: "Part Category updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          navigate('/admin/manage-logistic/part-category');
        }
      }
  
    } catch (error) {
      console.error("Error updating Part Category:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };
  
  const backNavigate = () => {
    navigate("/admin/manage-logistic/part-category");
  };

  const PartCAtegoryINputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "part_category_name",
      label: "Part Category",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "part_category_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
    <div>
    {loading ? (
      <Loader/>
    ) : (
      <><div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Part Category</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please enter the category details
                </span>
                <DynamicForm
                  formConfig={PartCAtegoryINputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default EditPartCategory;
